import { WhatsNew } from '@/components/whats-new';

export default WhatsNew;
